import React from 'react';
import { useTranslation } from 'react-i18next';
import FlairIcon from '../../../../../atomic/atoms/FlairIcon';

const i18prefix = 'performanceReview.goals2.weightValidation';

type Props = {
  invalidEmployeeCount: number;
  onClick: () => void;
};

export const ManagerWeightValidationBadge: React.FC<
  React.PropsWithChildren<Props>
> = ({ invalidEmployeeCount, onClick }) => {
  const { t } = useTranslation();

  if (invalidEmployeeCount === 0) {
    return null;
  }

  return (
    <span
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      className="d-inline-flex align-items-center text-warning text-nowrap">
      <FlairIcon icon="alert-triangle-outline" size="sm" className="me-2" />
      {t(`${i18prefix}.managerBadge`, { count: invalidEmployeeCount })}
    </span>
  );
};
